module.exports = __webpack_public_path__ + "static/media/logo1.676380ac.png";